import type { SiteTopology } from "../types";
import { bessSite1 } from "./bessSite1";
import { bessSite2 } from "./bessSite2";

export const TOPOLOGIES: SiteTopology[] = [bessSite1, bessSite2];

export function topologyById(id: string): SiteTopology {
  const t = TOPOLOGIES.find((x) => x.id === id);
  if (!t) throw new Error(`Unknown topology: ${id}`);
  return t;
}
